// 费用明细
// 仓库明细

import { HttpGetWareList } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetWareList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/billingOrderTransaction/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getWarehouseList', 'getCusproductList', 'getFirstLevelList','getUserManageWarehouseList', 'getSecondLevelList', 'getThirdLevelList', 'getBillcusWareList']),
        ...mapGetters('common', ['getBussinessTypeList','getBillingDetailStatus']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.costmanage.bill', { defaultValue: "账单" }),
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: "业务类型" }),
                    key: 'EQ_businessType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBussinessTypeList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.adjustment.list_firstcategory', { defaultValue: "一级分类" }),
                    key: 'EQ_firstBillingCategoryId',
                    options: this.getFirstLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },
                {
                    label: this.$t('fbb.adjustment.list_secondcategory', { defaultValue: "二级分类" }),
                    key: 'EQ_secondBillingCategoryId',
                    options: this.getSecondLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },
                {
                    label: this.$t('fbb.adjustment.list_thirdcategory', { defaultValue: "三级分类" }),
                    key: 'EQ_thirdBillingCategoryId',
                    options: this.getThirdLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },

                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: "计费单号" }),
                    key: 'EQ_relOrderNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.costmanage.distinguish_number', { defaultValue: "识别号" }),
                    key: 'EQ_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.container_no', { defaultValue: "集装箱号" }),
                    key: 'EQ_containerNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "SKU",
                    key: 'EQ_relSku',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                //     // on: {
                //     //     'on-change': function(value, label, attach = {}) {
                //     //         if(label=='已出账'){
                //     //             this.formData = {
                //     //                 ...this.formData,
                //     //                 'search[NE_billId]':0
                //     //             }
                //     //         }
                //     //     },
                //     // }
                //     // on: {
                //     //     'on-change': val => {
                //     //         console.log(val);
                //     //         if(val==1){
                //     //             this.key="NE_billId";
                //     //             this.val=0;
                //     //         }
                //     //     }
                //     // },
                //     // on: {
                //     //     'on-attach': (attach) => { this.formData.orgWarehouseCode = attach.code }
                //     // },
                //     // on: {
                //     //     'on-change': (val) => {
                //     //         // const data = this.productList.find(item => item.sku == val);
                //     //         this.boundFormData = { sku: val }
                //     //     }
                //     // },
                // },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.organization', { defaultValue: '组织' }) + '/' + this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                key: 'organizationName',
                render: (h, { row }) => {
                    return <div>
                        <div>{row.organizationName}</div>
                        <div>{row.orgWarehouseCode}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.costmanage.bill', { defaultValue: "账单" }),
                key: 'billNo',
                width: 100,
                render: (h, { row }) => {
                    return <div>
                        {this.$t('fbb.costmanage.bill', { defaultValue: "账单" })} : {row.billNo}
                        <div>状态:{row.billId == 0 ? this.$t('fbb.costmanage.not_out_bill', { defaultValue: '未出账' }) : this.$t('fbb.costmanage.has_out_bill', { defaultValue: '已出账' })}</div>
                    </div>
                }
            },
            {
                // title: '业务类型/一级分类/二级分类/三级分类',
                title: `${this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' })}/${this.$t('fbb.adjustment.list_firstcategory', { defaultValue: '一级分类' })}/${this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' })}/${this.$t('fbb.adjustment.list_thirdcategory', { defaultValue: '三级分类' })}`,
                width: 250,
                render: (h, { row }) => {
                    let businessType = row.businessType
                    const { label } = this.getBussinessTypeList.find(function (item) {
                        return item.value == businessType
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.firstBillingCategoryName}</div>
                        <div>{row.secondBillingCategoryName}</div>
                        <div>{row.thirdBillingCategoryName}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.line', { defaultValue: '项目' }) + '/SKU',
                render: (h, { row }) => {
                    return <div>
                        <div>{row.lineName || '--'}</div>
                        <div>{row.relSku || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }) + '*' + this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
                width: 90,
                sortable: true,
                render(h, { row }) {
                    return <div>{row.rate || '--'} * {row.count || '--'}</div>
                }

            },
            {
                title: this.$t('fbb.costmanage.take_goods_diffcult_level', { defaultValue: '拣货难度系数' }),
                width: 100,
                sortable: true,
                render(h, { row }) {
                    return <div>{row.otherCoefficient || '--'}</div>
                }

            },
            {
                title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
                sortable: true,
                render(h, { row }) {
                    return `${row.cost} ${row.currency || 'USD'}`
                }

            },
            {
                // title: '计费单号/识别号/集装箱号',
                title: `${this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' })}/${this.$t('fbb.costmanage.distinguish_number', { defaultValue: '识别号' })}/${this.$t('fbb.inbound.container_no', { defaultValue: '集装箱号' })}`,
                width: 170,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.relOrderNo || '--'}</div>
                        <div>{row.sourceNo || '--'}</div>
                        <div>{row.containerNo || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.notes', { defaultValue: '备注' }),
                key: 'remark',

            },
            {
                title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                key: 'createdAt',
                width: 80,
            }];
        },
    },
};




